import React from "react";
import StyledTableCell  from "./tableStyles";

interface ColumnDef<T> {
  key: keyof T | string;
  id: keyof T | string;
  label: string;
  align?: "left" | "right" | "center";
  width?: number;
  render?: (value: any, row: T) => React.ReactNode;
  fontSize?: string;
  truncate?: number;
  wrap?: boolean;
}

interface TableRowContentProps<T> {
  row: T;
  columns: ColumnDef<T>[];
}

export default function TableRowContent<T>({
  row,
  columns,
}: TableRowContentProps<T>) {
  return (
    <>
      {columns.map((column) => {
        const value = row[column.key as keyof T];
        const displayValue = column.render
          ? column.render(value, row)
          : (value as React.ReactNode);
        const truncatedValue =
          column.truncate && typeof value === "string"
            ? value.length > column.truncate
              ? `${value.slice(0, column.truncate)}...`
              : value
            : displayValue;

        return (
          <StyledTableCell
            key={column.id as string}
            align={column.align || "left"}
            style={{ width: column.width }}
            fontSize={column.fontSize}
            truncate={column.truncate}
            wrap={column.wrap}
          >
            {truncatedValue}
          </StyledTableCell>
        );
      })}
    </>
  );
}
